<template>
  <div>
    <form data-vv-scope="step-3" autocomplete="off" @keydown.enter.prevent>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Adjuntar Documento</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-9">
          <vs-input
            class="w-100"
            label="Documento Principal (Si piensa firmar
            electrónicamente no debe ser escaneado) (*)"
            name="mainFileName"
            readonly
            v-model="step.mainFile.name"
            v-validate="'required'"
            :danger="errors.has('step-3.mainFileName')"
            :danger-text="errors.first('step-3.mainFileName')"
            autocomplete="off"
          />
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <UploadFile
            permission="*"
            accept=".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc"
            text="Seleccionar"
            :max-size-in-mb="30"
            v-model="step.mainFile"
            upload-to="ed"
            :button-class="{ 'btn-block': true, 'mb-5': errors.has('step-3.mainFileName') }"
            container-class="w-100"
          />
        </div>
        <div class="col-md-12">
          <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
               style="height: 32px;">
          <span class="span-text-validation">
            {{ error.message }}
          </span>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-9">
          <vs-input
            class="w-100"
            label="Archivo Adjunto"
            name="additionalFileName"
            v-model="additionalFile.name"
            readonly
            autocomplete="off"
          />
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <UploadFile
            permission="*"
            text="Seleccionar"
            accept=".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc"
            v-model="additionalFile"
            upload-to="ed"
            :max-size-in-mb="30"
            button-class="btn-block"
            container-class="w-100"
            @input="addAdditionalFile()"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="Object.keys(step.mainFile).length">
        <div class="col-3">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="75px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ step.mainFile.name }}</b>
          </div>
        </div>
        <div class="col-3" v-for="file in step.additionalFiles" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="75px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              v-if="file.type !== 'respuesta'"
              @click="removeAdditionalFile(file.id)"
            />
            <b-badge
              v-if="file.type === 'respuesta'"
              variant="light-info"
              class="mr-2"
            >
              respuesta
            </b-badge>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';

export default {
  mixins: [WizardStep, FindTypeDocumentMixin],
  components: {
    UploadFile
  },
  data() {
    return {
      error: {
        message: ''
      },
      step: {
        mainFile: {},
        additionalFiles: [],
        relatedDocuments: [],
        relatedDocumentsSelected: [],
        document: '0',
        ...this.draft
      },
      additionalFile: {},
      relatedDocument: {
        type: '',
        number: ''
      }
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'step.mainFile.name': function () {
      this.$validator.reset();
    }
  },
  methods: {
    async addAdditionalFile() {
      this.step.document = '1';
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.step.additionalFiles.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.step.document = '0';
      this.additionalFile.name = '';
      this.step.additionalFiles = this.step.additionalFiles.filter((file) => file.id !== fileId);
    },
    async addRelatedDocument() {
      const isValid = await this.validateForm('step-3-part-2');

      if (!isValid) {
        return;
      }

      const row = {
        id: this.relatedDocument.length,
        type: this.relatedDocument.type,
        number: this.relatedDocument.number
      };
      const isSelected = this.step.relatedDocumentsSelected
        .some((relatedDoc) => relatedDoc.id === row.id
          && relatedDoc.type === row.type && relatedDoc.number === row.number);

      if (!isSelected) {
        this.step.relatedDocuments.push(row);
        this.step.relatedDocumentsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta referencia',
          {
            title: '¡HEEEY!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }

      this.relatedDocument.type = '';
      this.relatedDocument.number = '';
      await this.$validator.reset();
    },
    async isValid() {
      return this.validateForm('step-3');
    }
  }
};

</script>
